import { useEffect, useState } from "react";

import { useQueueInfo } from "@/hooks/requestQueue/useQueueInfo";

import { MidnightWarningModal } from "./MidnightWarningModal";
import {
    StyledClockIcon,
    StyledCountdownContainer,
    StyledCountdownInner,
    StyledTimeText,
} from "./Styled";

interface TimeRemaining {
    hours: string;
    minutes: string;
    seconds: string;
}

export const MidnightCountdown = () => {
    const { hasPending } = useQueueInfo();
    const [timeRemaining, setTimeRemaining] = useState<TimeRemaining | null>(
        null,
    );
    const [isVisible, setIsVisible] = useState(false);
    const [isWarningVisible, setIsWarningVisible] = useState(false);

    useEffect(() => {
        if (!hasPending) {
            return;
        }
        const calculateTimeRemaining = (): TimeRemaining | null => {
            const now = new Date();
            const midnight = new Date();
            midnight.setHours(24, 0, 0, 0);

            const diff = midnight.getTime() - now.getTime();
            const twoHoursInMs = 2 * 60 * 60 * 1000;

            if (diff > twoHoursInMs || diff <= 0) {
                return null;
            }

            const hours = Math.floor(diff / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            return {
                hours: String(hours).padStart(2, "0"),
                minutes: String(minutes).padStart(2, "0"),
                seconds: String(seconds).padStart(2, "0"),
            };
        };

        const updateTimer = () => {
            const remaining = calculateTimeRemaining();
            setTimeRemaining(remaining);
            setIsVisible(remaining !== null);
        };

        updateTimer();

        const interval = setInterval(updateTimer, 1000);

        return () => clearInterval(interval);
    }, [hasPending]);

    if (!isVisible || !timeRemaining || !hasPending) {
        return null;
    }

    return (
        <StyledCountdownContainer>
            <StyledCountdownInner onClick={() => setIsWarningVisible(true)}>
                <StyledClockIcon />
                <StyledTimeText>
                    {timeRemaining.hours}:{timeRemaining.minutes}:
                    {timeRemaining.seconds}
                </StyledTimeText>
            </StyledCountdownInner>

            <MidnightWarningModal
                isOpen={isWarningVisible}
                onClose={() => setIsWarningVisible(false)}
            />
        </StyledCountdownContainer>
    );
};
